import { Placement, Tooltip } from '@nextui-org/react';
import React, { ReactNode } from 'react';

import { HelpContainer, StyledInfoIcon, TooltipContent } from './HelpTooltip.styles';

const HelpTooltip = ({
  $helpText,
  placement = 'top',
  portalClassName = 'tooltip-wrapper',
}: {
  $helpText: string | ReactNode;
  placement?: Placement;
  portalClassName?: string;
}) => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <Tooltip
      content={<TooltipContent>{$helpText}</TooltipContent>}
      placement={placement}
      visible={isOpen}
      portalClassName={portalClassName}
      onVisibleChange={setIsOpen}
    >
      <HelpContainer onMouseEnter={() => setIsOpen(true)} onMouseLeave={() => setIsOpen(false)}>
        <StyledInfoIcon />
      </HelpContainer>
    </Tooltip>
  );
};

export default HelpTooltip;
